import { z } from 'zod';

import {
  LOS_ALLOWED_CHARACTERS_MESSAGE,
  LOS_ALLOWED_CHARACTERS_REGEX,
  LOS_REQUIRED_MESSAGE,
} from '../../constants';

export default function getLOSBaseSchema(maxInputLength: number) {
  return z
    .string({ message: LOS_REQUIRED_MESSAGE })
    .trim()
    .regex(LOS_ALLOWED_CHARACTERS_REGEX, { message: LOS_ALLOWED_CHARACTERS_MESSAGE })
    .min(1, { message: LOS_REQUIRED_MESSAGE })
    .max(maxInputLength, {
      message: `ความยาวต้องไม่เกิน ${maxInputLength} ตัวอักษร`,
    });
}
